//
// navbar.js
// Theme module
//

const navbarTogglable = document.querySelectorAll('.navbar-togglable');
const navbarCollapse = document.querySelectorAll('.navbar-collapse');
const windowEvents = ['load', 'scroll'];

let isLight = false;

function makeNavbarDark(navbar) {
  navbar.classList.remove('navbar-light');
  navbar.classList.remove('bg-white');
  navbar.classList.remove('border-bottom');
  navbar.classList.remove('border-gray');
  navbar.classList.add('navbar-dark');
  document.getElementById("logo_img").src = "/assets/img/logoWTY-24-light.svg";
  // navbar.removeAttribute('style');

  isLight = false;
}

function makeNavbarLight(navbar) {
  navbar.classList.remove('navbar-dark');
  navbar.classList.add('navbar-light');
  navbar.classList.add('bg-white');
  navbar.classList.add('border-bottom');
  navbar.classList.add('border-gray');
  document.getElementById("logo_img").src = "/assets/img/logoWTY-24.svg";


  // navbar.style.setProperty('backdrop-filter', 'blur(8px)', 'important'); 
  // navbar.style.setProperty('background-color', 'rgba(255, 255, 255, 0.9)', 'important');  


  isLight = true;
}

function toggleNavbar(navbar) {
  const scrollTop = window.scrollY;

  if (scrollTop && !isLight) {
    makeNavbarLight(navbar);
  }

  if (!scrollTop) {
    makeNavbarDark(navbar);
  }
}

function overflowHide() {
  const scrollbarWidth = getScrollbarWidth();

  document.documentElement.style.overflow = 'hidden';
  document.body.style.paddingRight = scrollbarWidth + 'px';
}

function overflowShow() {
  document.documentElement.style.overflow = '';
  document.body.style.paddingRight = '';
}

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

navbarTogglable.forEach(function(navbar) {

  windowEvents.forEach(function(event) {
    window.addEventListener(event, function() {
      toggleNavbar(navbar);
    });
  });
});

navbarCollapse.forEach(function(collapse) {
  collapse.addEventListener('show.bs.collapse', function() {
    overflowHide();
  });

  collapse.addEventListener('hidden.bs.collapse', function() {
    overflowShow();
  });
});
